var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('div',{staticClass:"funnel-header"},[_vm._v("\n    本月产品转换漏斗\n  ")]),_c('div',{ref:"funnel",staticStyle:{"height":"530px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }